// extracted by mini-css-extract-plugin
export default {"top-button":"top-button--ZCh5L"};